/**
 * Formata a distância de tempo relativa ao momento atual
 * 
 * @param {Date} date - Data para calcular a distância
 * @returns {string} - String formatada com a distância (ex: "Em 5min", "Em 2h30min")
 */
export const formatTimeDistance = (date) => {
  if (!date || !(date instanceof Date)) return '';
  
  const now = new Date();
  const diffMs = date.getTime() - now.getTime();
  const diffMinutes = Math.floor(diffMs / 60000);
  
  if (diffMinutes < 0) {
    return 'Em andamento';
  } else if (diffMinutes === 0) {
    return 'Agora';
  } else if (diffMinutes < 60) {
    return `Em ${diffMinutes} min`;
  } else {
    const hours = Math.floor(diffMinutes / 60);
    const minutes = diffMinutes % 60;
    
    if (minutes === 0) {
      return `Em ${hours}h`;
    } else {
      return `Em ${hours}h${minutes}min`;
    }
  }
};

/**
 * Formata a hora no formato HH:MM
 * 
 * @param {Date} date - Data para extrair a hora
 * @returns {string} - Hora formatada (ex: "14:30")
 */
export const formatHourMinute = (date) => {
  if (!date || !(date instanceof Date)) return '';
  
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  
  return `${hours}:${minutes}`;
};

/**
 * Formata a data no formato DD/MM/YYYY
 * 
 * @param {Date} date - Data para formatar
 * @returns {string} - Data formatada (ex: "25/12/2023")
 */
export const formatDate = (date) => {
  if (!date || !(date instanceof Date)) return '';
  
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  
  return `${day}/${month}/${year}`;
};

/**
 * Formata a data e hora no formato DD/MM/YYYY HH:MM
 * 
 * @param {Date} date - Data para formatar
 * @returns {string} - Data e hora formatadas (ex: "25/12/2023 14:30")
 */
export const formatDateTime = (date) => {
  if (!date || !(date instanceof Date)) return '';
  
  return `${formatDate(date)} ${formatHourMinute(date)}`;
}; 